export default "__VITE_ASSET__CxChy7NC__"